module.exports = __webpack_public_path__ + "img/m-icon-s-cross.ceff289c.png";